import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href,
  ...props
}: ButtonProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else if (onClick) {
      onClick();
    } else {
      document.getElementById('offer-section')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-gold hover:bg-gold-light text-navy font-bold py-4 px-8 rounded-sm shadow-lg transition-colors duration-300 w-full md:w-auto text-sm md:text-base tracking-wide uppercase ${className}`} {...props} data-id="element-13">
      {children}
    </motion.button>;
}